import { ReactElement, useContext, useState } from 'react';

import { Field } from 'formik';
import gridStyle from '@pages/forms/Grid.module.scss';
import { Alert, Button, Modal, TextInput } from '@components';
import VicFinesContext from '@pages/forms/VicFinesFormContext';
import InfoIcon from '../../../../images/info.svg';
import QuestionIcon from '../../../../images/question.svg';
// import mailRef from '../../../../images/refNo_mail.jpg';
import styles from './InstalmentStep1.module.scss';

const isIneligibleCode = 'isIneligible'; // Error Message 3
const isNominatedCode = 'isNominated'; // Error Message 4

function InstalmentStep1(): ReactElement {
  const { apiError, tooltips } = useContext(VicFinesContext);
  const validTitle = Object.keys(tooltips).filter((v) => v.includes('obligationlocationonformstep1modal'));
  const modalContent = tooltips[validTitle[0]];
  const titleText = validTitle[0].substring(validTitle[0].indexOf('|'), validTitle[0].length).replaceAll('|', ' ');

  const navigateToPayFines = () => {
    window.open('/Your-options/Pay-your-fine', '_blank');
  };
  const navigateToViewFines = () => {
    window.open('/Your-options/View-your-fine', '_blank');
  };

  // Error Code 2
  const IneligibleObligationAlertContentError3 = (): ReactElement => (
    <>
      <strong>You're not eligible to apply for a payment arrangement.</strong>
      <p>
        If you would like to speak to someone, call Fines Victoria on
        {' '}
        <a href="tel:0392008111" title="Fines Victoria phone number">
          03 9200 8111
        </a>
        {' '}
        or
        {' '}
        <a href="tel:1300369819" title="Fines Victoria phone number">
          1300 369 819
        </a>
        {' '}
        (regional callers).
      </p>
      <br />
      <p>We are available Monday to Friday, 8am to 6pm (except public holidays).</p>
      <br />
      <p>Pay now to avoid additional costs.</p>

      <div className={styles.errorMessageButtons}>
        <Button onClick={navigateToPayFines} color="blue" size="small_medium">
          Pay your fines
        </Button>
        <Button onClick={navigateToViewFines} color="blue" size="small_medium">
          View your fines
        </Button>
      </div>
    </>
  );

  // Error Code 1
  const NominatedIneligibleAlertContentError = (): ReactElement => (
    <>
      <p>The obligation you have entered may be closed or may have been nominated to a third party. Check you've entered it correctly and try again.</p>
      <br />
      <p>
        If you have just become aware of your fine, call Fines Victoria on
        {' '}
        <a href="tel:0392008111" title="Fines Victoria phone number">
          03 9200 8111
        </a>
        {' '}
        or
        {' '}
        <a href="tel:1300369819" title="Fines Victoria phone number">
          1300 369 819
        </a>
        {' '}
        (regional callers).
      </p>
    </>
  );

  // For Any other error
  const InstalmentStep1AlertContent = (): ReactElement => <p>{`${apiError?.Error}`}</p>;

  const [isOpenHelp, setOpenHelp] = useState(false);
  // const [smallScreen, setMatches] = useState(window.matchMedia('(max-width: 1150px)').matches);

  const closeNotifications = () => {
    setOpenHelp(false);
  };

  const InstalmentStep1NoteContent = (): ReactElement => (
    <>
      <p>You will need to enter the fine's obligation number, infringement number or court case number, the offence date and some other details about yourself or your vehicle.</p>
      <br />
      <span>
        If you do not have these details please contact us on
        {' '}
        <a href="tel:0392008111" title="Fines Victoria phone number">
          03 9200 8111
        </a>
        {' '}
        or
        {' '}
        <a href="tel:1300369819" title="Fines Victoria phone number">
          1300 369 819
        </a>
        {' '}
        (regional callers).
      </span>
    </>
  );

  const notificationInformation = (): ReactElement => (
    // eslint-disable-next-line react/no-danger
    <div className={styles.accordContent} dangerouslySetInnerHTML={{ __html: modalContent }} />
  );

  return (
    <>
      <div className={gridStyle.form}>
        <div className="vfH2">Your fine</div>
        <span className="subHeadingH3">
          At this stage of the application, you only need to provide the details of one of your fines - even if you are dealing with multiple matters.
        </span>
        {apiError?.Error === isIneligibleCode && <Alert icon={InfoIcon} message={<IneligibleObligationAlertContentError3 />} theme="error" classAlt={styles.boxheight} />}
        {apiError?.Error === isNominatedCode && <Alert icon={InfoIcon} message={<NominatedIneligibleAlertContentError />} theme="error" classAlt={styles.boxheight} />}
        {apiError?.Error
        && apiError?.Error !== isIneligibleCode
        && apiError?.Error !== isNominatedCode
        && <Alert icon={InfoIcon} message={<InstalmentStep1AlertContent />} theme="error" classAlt={styles.boxheight} />}
        <Field
          name="OBLIGATION_NUMBER"
          component={TextInput}
          title="Obligation number, infringement number or court case number"
          icon={QuestionIcon}
          iconPosition="end"
          iconClick={() => setOpenHelp(true)}
          isMandatory
          autocomplete="off"
        />
        <div>If you have already paid this fine, you cannot request a payment arrangement.</div>
        {isOpenHelp && <Modal show close={closeNotifications} title={titleText} content={notificationInformation()} />}
      </div>
      <Alert message={<InstalmentStep1NoteContent />} theme="info" icon={InfoIcon} />
    </>
  );
}

export default InstalmentStep1;
